import { createAction, props } from '@ngrx/store';
import { BizBrand } from '../../models/biz-brand';

// Action to load community Brand
export const loadBizBrand = createAction(
  '[Product] Load Biz Brand'
);

// Action to handle successful loading of community Brand data
export const loadBizBrandSuccess = createAction(
  '[Product] Load Biz Brand Success',
  props<{ bizBrand: BizBrand[] }>() // Correct type reference, array of 'Brand' objects
);

// Action to handle failure in loading community Brand data
export const loadBizBrandFailure = createAction(
  '[Product] Load Biz Brand Failure',
  props<{ error: any }>()
);
